module.exports = __webpack_public_path__ + "img/13.71b2924f.jpg";